// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2xv1X","addWidgetButton":"Header_addWidgetButton__VMiei","dashboardTabs":"Header_dashboardTabs__1-TY1","active":"Header_active__2DT0c"};